//TODO: remove this util
export default {
  usernameValidationRegex: /^[A-Za-z0-9@._-]+$/,
  passwordValidationRegex: /^(?=.*\d).{8,}$/,
};
